module.exports = __webpack_public_path__ + "img/18_6.0696bb0d.png";